<template>
  <Popup
    v-model="show"
    class="account-language-sheet"
    position="bottom"
    round
  >
    <div class="account-language-sheet__content">
      <header>
        <h2>{{ $t('languageSettings') }}</h2>
        <button type="button" :aria-label="$t('close')" @click="close">
          <Icon name="cross" />
        </button>
      </header>

      <div class="account-language-sheet__options">
        <button
          v-for="locale in availableLocales"
          :key="locale.code"
          type="button"
          :class="{ 'is-selected': currentLocale === locale.code }"
          @click="currentLocale = locale.code"
        >
          <span>{{ locale.name }}</span>
          <Icon v-if="currentLocale === locale.code" name="checked" />
        </button>
      </div>

      <button class="account-language-sheet__confirm" type="button" @click="confirm">
        {{ $t('confirm') }}
      </button>
    </div>
  </Popup>
</template>

<script>
import { Icon, Popup } from 'vant';
import { LANGUAGE } from '@/common/constants';

export default {
  name: 'LanguageSwitcher',
  components: {
    Icon,
    Popup,
  },
  data() {
    return {
      show: false,
      availableLocales: [
        { code: LANGUAGE.en, name: 'English' },
        { code: LANGUAGE.id, name: 'Bahasa Indonesia' },
      ],
      currentLocale: [LANGUAGE.en, LANGUAGE.id].includes(this.$i18n.locale)
        ? this.$i18n.locale
        : LANGUAGE.en,
    };
  },
  methods: {
    open() {
      this.currentLocale = [LANGUAGE.en, LANGUAGE.id].includes(this.$i18n.locale)
        ? this.$i18n.locale
        : LANGUAGE.en;
      this.show = true;
    },
    close() {
      this.show = false;
    },
    confirm() {
      this.$i18n.locale = this.currentLocale;
      localStorage.setItem('language', this.currentLocale);
      this.close();
    },
  },
};
</script>

<style lang="less" scoped>
::v-deep .account-language-sheet {
  width: 100%;
  max-width: 750px;
  overflow: hidden;
  border-radius: 32px 32px 0 0;
  background: #ffffff;
}

.account-language-sheet__content {
  padding: 0 32px calc(16px + env(safe-area-inset-bottom));
  box-sizing: border-box;

  > header {
    display: flex;
    min-height: 96px;
    align-items: center;
    border-bottom: 2px solid #e5eaf3;

    h2 {
      min-width: 0;
      margin: 0;
      flex: 1;
      overflow: hidden;
      color: #070d3f;
      font-size: 32px;
      font-weight: 500;
      line-height: 48px;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    button {
      display: flex;
      width: 80px;
      height: 80px;
      align-items: center;
      justify-content: center;
      padding: 0;
      border: 0;
      background: transparent;
      color: #070d3f;
      font-size: 40px;
    }
  }
}

.account-language-sheet__options {
  display: flex;
  padding-top: 16px;
  flex-direction: column;
  gap: 16px;

  button {
    display: flex;
    width: 100%;
    min-height: 88px;
    align-items: center;
    justify-content: space-between;
    padding: 20px 28px;
    border: 2px solid #e5eaf3;
    border-radius: 20px;
    background: #f8faff;
    color: #070d3f;
    font-size: 26px;
    font-weight: 500;
    line-height: 36px;
    text-align: left;
    box-sizing: border-box;

    &.is-selected {
      border-color: rgba(11, 69, 255, 0.45);
      background: #eaf3ff;
      color: #0b45ff;
    }

    .van-icon {
      flex-shrink: 0;
      color: #0b45ff;
      font-size: 36px;
    }
  }
}

.account-language-sheet__confirm {
  width: 100%;
  height: 92px;
  margin-top: 16px;
  border: 0;
  border-radius: 20px;
  background: linear-gradient(90deg, #0b45ff, #2778ff);
  color: #ffffff;
  font-size: 30px;
  font-weight: 500;
}
</style>
